<template>
    <div>
        <main class="app-content">
      <div class="app-title">
        <div class="col-md-5">
          <v-autocomplete
            :items="clientes"
            v-model="selecteditem"
            dense
            color="#17a2b8"
            outlined
            clearable
            hide-details
            hide-selected
            item-text="Nombre"
            item-value="idpersona"
            label="Seleccione Contribuyente ..."        
            @change="getItems()"     
          >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>
                <strong>No se contro ningun registro</strong>
              </v-list-item-title>
            </v-list-item>
          </template>          
          </v-autocomplete>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <v-btn class="white--text" color="#009688" @click="rutas('Nuevo')">
              <v-icon left>mdi-cash-usd</v-icon>
              NUEVO
          </v-btn>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="tile">
            <div class="tile-body" v-if="$store.getters.getCliente">
              <template>
                  <v-card>
                    <v-tabs
                      color="deep-purple accent-4"
                      right
                      v-model="tab"
                    >
                      <v-tab href="#tab-1" @click="$router.push('/pagos/transacciones')">Listado Pagos</v-tab>
                      <v-tab href="#tab-2" @click="$router.push('/pagos/tipopagos')">Tipo Pagos</v-tab>
                    <v-tabs-items v-model="tab">
                      <v-tab-item value="tab-1">
                      </v-tab-item>
                      <v-tab-item value="tab-2">
                      </v-tab-item>
                    </v-tabs-items>
                    </v-tabs>
                  </v-card>
                </template>
                <template>
                <v-card>
                    <v-card-title>
                    {{titlerouter}}
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        color="teal"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table
                    :headers="headers"
                    :items="dataitems"
                    :search="search"                    
                    >
                    <template v-slot:[`item.cliente`]="{item}">
                      <p>{{item.cliente}}</p>
                      <strong>Nit: {{item.nit}}</strong>
                      
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <button class="btn btn-info btn-sm"  @click="printPDF(item.idtransaccion)" data-toggle="modal" data-target="#modalRegistro"><v-icon class="text-white">mdi-printer</v-icon></button>                      
                            <button class="btn btn-danger btn-sm" @click="deleteSwal(item.iddetalle)"><v-icon class="text-white">mdi-cash-remove</v-icon></button>
                        </div>       
                    </template>
                    <template v-slot:no-data>
                        <button class="btn btn-primary text-white" type="button" @click="getItems">Cargar Información</button>
                    </template>
                    </v-data-table>
                </v-card>
                </template>
            </div>
            <div class="tile-body" v-else>
              <!-- SINO SE HA SELECCIONADO CONTRIBUYENTE-->
               <v-row>
                 <v-col>
                    <h3><v-icon class="teal--text mdi-48px">mdi-arrow-up-bold-circle-outline</v-icon>Primero debe seleccionar un Contribuyente</h3>
                 </v-col>
               </v-row>
            </div>
          </div>
        </div>
      </div>
    </main>
  
    </div>
</template>
<script>
import axios from "axios";
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
    name:'Transaccion',
    data() {
        return {
            titlerouter:'Control de Pagos',
            dataitems:[],
            clientes:[],
            tab:'tab-1',
            editedIndex: -1,
            search: '',
            headers: [
            { text: 'Codigo', value: 'codigo' },
            { text: 'Fecha ', value: 'fecha' },
            { text: 'Cliente', value: 'cliente' },
            { text: 'Categoria', value: 'categoria'},
            { text: 'Descripcion', value: 'descripcion'},
            { text: 'Total', value: 'total'},
            { text: 'Tipo', value: 'tipo'},
            { text: 'Atendido por', value: 'usuario'},
            { text: 'Opciones', value: 'actions', sortable: false },
            ],
        //Transaccion    
        transaccion:{
          codigo:'',
          fecha:moment().format('YYYY-MM-DD'),
          idpersona:false,
          idusuario:this.$store.getters.getCurrentUser.IdUsuario,
          descuento:0,
          total:'',
          tipo:'Ingreso',
        },
        cleartransaccion:{
          codigo:'',
          fecha:moment().format('YYYY-MM-DD'),
          idpersona:false,
          idusuario:this.$store.getters.getCurrentUser.IdUsuario,
          descuento:0,
          total:0,
          tipo:'Ingreso',
        },     
       }
    },
    created() {
      this.getContribuyentes()
      if(this.$store.getters.getCliente){
        this.getItems()
      }
        
    },
    computed:{
      selecteditem: {
        get () {
          return this.$store.getters.getCliente
        },
        set (value) {
          console.log(value)
          this.$store.dispatch('setCliente', value)
        }
      },
    },
    methods: {
        getItems(){
            axios.get(`${this.$store.state.urlapi}/pagos/transaccion/${this.$store.getters.getCliente}`,{headers:{'auth-user':this.$store.state.token}})
            .then(response=>{
                if(response.status==200){
                  this.dataitems = response.data;
                }else{
                  this.dataitems =[]
                }
            }).catch(error=>{
                console.log(error)
            })        
        },
        getContribuyentes(){
            axios.get(`${this.$store.state.urlapi}/contribuyentes/`,{headers:{'auth-user':this.$store.getters.getToken}})
            .then(response=>{
                if(response.data.length>0){
                    this.clientes = response.data;
                }
            }).catch(error=>{
                console.log(error)
            })        
        },
        eliminarItem(id){
              axios.delete(`${this.$store.state.urlapi}/pagos/transacciondetalle/${id}`,{headers:{'auth-user': this.token}})
              .then(()=>{
                this.getItems()  
                this.exitoSwal()         
              }).catch(error=>{
                this.errorSwal()
                console.log(error)
              })
        },
        printPDF(id){
         window.open('/reportes/pagos/index.php?id='+id,"blank")
        },
        rutas(ruta){

            switch (ruta) {
              case 'Nuevo':
                this.$router.push(`/pagos/nuevo`)
                break;
            
              default:
                break;
            }
        },
        //NOTIFICACIONES SWAL ALERT
        exitoSwal(){
            Swal.fire({
                icon: 'success',
                title: '¡Realizado!',
                showConfirmButton: false,
                timer: 1500
            })
        },
        errorSwal(){
            Swal.fire({
                icon: 'error',
                title: 'Ocurrio un Error :(',
                text:'Si el error persiste contacte a soporte técnico'
            })
        },
        deleteSwal(Id){
         Swal.fire({
            title: 'Presione Sí para eliminar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText:'Cancelar',
            confirmButtonText: 'Sí'
          }).then((result) => {
            if (result.isConfirmed) {
              this.eliminarItem(Id);
            }
          })
       }
      
    },
}
</script>

<style scoped>
a{
text-decoration: none;
}
.Bold { font-weight: bold; }
p{
 margin :0 0 0 0; 
 padding: 0;
}
</style>